import React from 'react';
import useMfaPanelStore from './store';
import MfaPanelCard from './mfa-panel-card';
import { useResponsive } from 'hooks';

// Mounted once in the page layout. Renders one floating card per open panel.
export default function MfaPanelHost() {
  const panels = useMfaPanelStore((state) => state.panels);
  const { isDesktop } = useResponsive();

  if (!panels.length) return null;

  return (
    <React.Fragment>
      {panels.map((panel, index) => (
        <MfaPanelCard
          key={panel.deviceId}
          deviceId={panel.deviceId}
          z={panel.z}
          index={index}
          hasTriagePane={isDesktop}
        />
      ))}
    </React.Fragment>
  );
}
